import React, { useMemo } from 'react';
import { ProfileSelectionGrid } from '../ProfileSelectionGrid/ProfileSelectionGrid.tsx';
/** Color grid for the edit profile dialog. */ export const EditProfileColorSelector = ({ colors, selectedColor, onColorSelect, onDisabledColorSelect })=>{
    const options = useMemo(()=>colors.map((color)=>({
                id: color.colorId,
                name: color.name,
                imageUrl: color.imageUrl,
                disabled: color.disabled,
                dimmed: color.disabled && !color.freeAtStore
            })), [
        colors
    ]);
    return /*#__PURE__*/ React.createElement(ProfileSelectionGrid, {
        options: options,
        selectedId: selectedColor,
        onSelect: onColorSelect,
        onDisabledSelect: onDisabledColorSelect
    });
};
